var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaIcon7(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.314,
    height: 36.314,
    viewBox: "0 0 36.314 36.314",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4471",
    "data-name": "Group 4471",
    transform: "translate(1.25 1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "heart",
    d: "M17.626,4.341a4.584,4.584,0,0,0-6.484,0l-.883.883-.883-.883a4.585,4.585,0,0,0-6.484,6.484l.883.883,6.484,6.484,6.484-6.484.883-.883a4.584,4.584,0,0,0,0-6.484Z",
    transform: "translate(7.884 6.165)",
    fill: "none",
    stroke: "#ef4444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "message-circle",
    d: "M36.814,18.968a15.742,15.742,0,0,1-1.691,7.138,15.968,15.968,0,0,1-14.277,8.829,15.742,15.742,0,0,1-7.138-1.691L3,36.814,6.569,26.106a15.742,15.742,0,0,1-1.691-7.138A15.968,15.968,0,0,1,13.708,4.691,15.742,15.742,0,0,1,20.846,3h.939A15.93,15.93,0,0,1,36.814,18.028Z",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#ef4444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon7);
export default __webpack_public_path__ + "static/media/media_icon7.8191da0331cc915ac147bfe8b7601a9a.svg";
export { ForwardRef as ReactComponent };